import React, { useMemo } from "react";

import { Box, Typography } from "@mui/material";
import { round, sum } from "lodash";
import { makeStyles } from "tss-react/mui";

import { MealDetailsFragment } from "@/gql/graphql";
import { calculateMacro } from "@/pages/Clients/ClientDetails/ClientDiary/Meals/utils/macros";

import { Cell } from "../store/Cell";
import MealPatternItem from "../store/MealPatternItem";
import { PlannedMeal } from "../store/PlannedMeal";
import { PlannedMealItem } from "../store/PlannedMealItem";

interface Props {
  items: PlannedMealItem[] | MealPatternItem[] | undefined;
}

const MealItemMacros: React.FC<Props> = ({ items }) => {
  const { classes } = useStyles();

  const totalEnergy = round(sum(items?.map((f) => f.energyKcal)));
  const totalCarbs = useMemo(
    () =>
      round(
        sum(
          items?.map((f) =>
            f instanceof MealPatternItem
              ? f.carbohydrateGrams
              : f.food.carbohydrateGrams
          )
        ),
        2
      ),
    [items]
  );
  const totalProteins = useMemo(
    () =>
      round(
        sum(
          items?.map((f) =>
            f instanceof MealPatternItem ? f.proteinGrams : f.food.proteinGrams
          )
        ),
        2
      ),
    [items]
  );
  const totalFat = useMemo(
    () =>
      round(
        sum(
          items?.map((f) =>
            f instanceof MealPatternItem ? f.fatGrams : f.food.fatGrams
          )
        ),
        2
      ),
    [items]
  );
  const calculate = calculateMacro(totalEnergy);
  const carbsPercent = calculate.carbsPercentage(totalCarbs);
  const proteinsPercent = calculate.proteinPercentage(totalProteins);
  const fatPercent = calculate.fatsPercentage(totalFat);

  return (
    <Box className={classes.root}>
      <Typography>
        C: {totalCarbs} g | {carbsPercent} %
      </Typography>
      <Typography>
        P: {totalProteins} g | {proteinsPercent} %
      </Typography>
      <Typography>
        F: {totalFat} g | {fatPercent} %
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles()({
  root: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 12,
  },
});

export default MealItemMacros;
